import { OperacoesWebAPI } from '../../utils/global';
import api from '../api'
export const modoEntradaService = {

    getAllAtivos: () => {
        return api.get(`${OperacoesWebAPI.ModoEntrada}/getallativos`)
            .then((res) => res)
            .catch(err => err)
    },
    post: (modoEntrada: any) => {

        return api.post(`${OperacoesWebAPI.ModoEntrada}`, modoEntrada)
    },
    put: (modoEntrada: any) => {
        return api.put(`${OperacoesWebAPI.ModoEntrada}`, modoEntrada)
    },

    delete: (modoEntradaID: number) => {
        return api.delete(`${OperacoesWebAPI.ModoEntrada}?id=${modoEntradaID}`)
    }
}